import React from 'react';
import chevronDown from '../../assets/images/chevron-down.svg';
import info from '../../assets/images/info.svg';
import caseStudies from '../../assets/images/case-studies.png';
import arrowGreen from '../../assets/images/arrow-green-small.png';
import partner1  from '../../assets/images/partner1.png';
import partner2  from '../../assets/images/partner2.png';
import partner3  from '../../assets/images/partner3.png';
import partner4  from '../../assets/images/partner4.png';

const GreatData = () => {
  return ( 
    <div className="great-data">
      <div className="row">
        <div className="col-md-8">
          <div className="text">
            <h2 className="text-primary fs-36 font-weight-normal">Great Data, Great Potential.</h2>
          <p className="fs-14">SmartDrive extends great commitment and responsibility to the safety of<br></br> your fleet and drivers. SmartDrive provides unprecedented driving<br></br> performance insights to the drivers to help save fuel or to improve safety on<br></br> the road. Equipped with video safety, predictive analytics, telematics,<br></br> compliance, and personalized performance program, SmartDrive is an<br></br> exceptional safety mentor. </p>
          <div className="row partners">
            <div className="col-md-3 mt-3">
              <img src={partner1} alt="Partner 1" />
            </div>
            <div className="col-md-3 mt-3 partner-logo">
              <img src={partner2} alt="Partner 2" />
            </div>
            <div className="col-md-3 mt-3 partner-logo">
              <img src={partner3} alt="Partner 3 partner-logo" />
            </div>
            <div className="col-md-3 mt-3 partner-logo">
              <img src={partner4} alt="Partner 4" />
            </div>
          </div>
          <div className="row fs-14">
            <div className="col-md-6 reduction">
              <h1 className="text-secondary fs-52 font-weight-light">53% <sup><img src={chevronDown} alt="Chevron Down" /></sup></h1>
              <p className="font-weight-bold text-black">Reduction in Collisions</p>
              <p className="font-weight-semibold">SmartDrive has helped reduce up to 53% of<br></br> total collisions, with video safety and<br></br> predictive analytics. </p>
            </div>
            <div className="col-md-6 alerts">
              <h1 className="text-secondary fs-52 font-weight-light">2.5 Mil <sup><img src={info} alt="Info" /></sup></h1>
              <p className="font-weight-bold text-black">Alerts Issued</p>
              <p className="font-weight-semibold">SmartDrive has generated up to 2.5 million<br></br> timely safety alerts that have helped prevent<br></br> potential mishaps.</p>
            </div>
          </div>
        </div>
      </div>
        <div className="col-md-4 text-right">
          <div className="great-data">
            <img src={caseStudies} alt=""Case Studies width="100%" height="720px" />
            <div className="case-studies text-left">
              <p className="font-weight-bold">Case <br></br>studies</p>
              <div className="text-right">
                <img src={arrowGreen} alt="Arrow Right" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  );
} 
 
export default GreatData;